import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TIME_ATTENDANCE_DISPLAY_LIMIT } from 'pages/TimeAttendance/constants';

import { PageDetails } from 'types/common/Table';
import {
  EditBreakingTimeRowType,
  EditWorkingTimeFormType,
  TimeAttendanceSearchFilters,
} from 'types/timeAttendance/timeAttendanceTypes';

export interface TimeAttendanceState {
  activeEditWorkingTimeId: string | null;
  activeBreakingTimeAttendanceId: string | null;
  isEdit: boolean;
  // customerModalOpen: boolean;
  EditWorkingTimeModalOpen: boolean;
  BreakingTimeModalOpen: boolean;
  // CustomerValues: CustomerFormType;
  // AdjustPointsValues: AdjustPointsFormType;
  EditWorkingTimeValues: EditWorkingTimeFormType;
  BreakingTimeValues: EditBreakingTimeRowType[];
  showAllValidateErrors: boolean;
  countSubmit: number;
  PageFilters: TimeAttendanceSearchFilters;
  PageDetails: PageDetails;
  // PointsHistoryModal: CustomerPointsHistoryModalState;
}

const formatDate = (date: Date) =>
  [
    date.getFullYear(),
    String(date.getMonth() + 1).padStart(2, '0'),
    String(date.getDate()).padStart(2, '0'),
  ].join('-');

const getDefaultDateRange = () => {
  const endDate = new Date();
  const startDate = new Date(endDate);

  // startDate.setDate(endDate.getDate() - 3);

  return {
    startDate: formatDate(startDate),
    endDate: formatDate(endDate),
  };
};

export const initialState: TimeAttendanceState = {
  activeEditWorkingTimeId: null,
  activeBreakingTimeAttendanceId: null,
  isEdit: false,
  countSubmit: 0,
  showAllValidateErrors: false,
  EditWorkingTimeModalOpen: false,
  BreakingTimeModalOpen: false,
  EditWorkingTimeValues: {
    id: '',
    officeCode: '',
    fullName: '',
    clockInAt: null,
    clockOutAt: null,
    note: '',
  },
  BreakingTimeValues: [],
  PageFilters: {
    branch: [],
    ...getDefaultDateRange(),
    officeID: null,
  },
  PageDetails: {
    entriesPerPage: TIME_ATTENDANCE_DISPLAY_LIMIT,
    currentPage: 0,
    inputPageValue: 1,
  },
};

const TimeAttendanceSlice = createSlice({
  name: 'TimeAttendance',
  initialState,
  reducers: {
    // setCustomerModalOpen(state, action: PayloadAction<boolean>) {
    //   state.customerModalOpen = action.payload;
    // },
    // setAdjustPointsModalOpen(state, action: PayloadAction<boolean>) {
    //   state.adjustPointsModalOpen = action.payload;
    // },
    setActiveEditWorkingTimeId(state, action: PayloadAction<string | null>) {
      state.activeEditWorkingTimeId = action.payload;
      state.isEdit = action.payload !== null;
    },
    setActiveWorkingTimeId(state, action: PayloadAction<string | null>) {
      state.EditWorkingTimeValues.id = action.payload || '';
    },
    setWorkingTimeModalOpen(state, action: PayloadAction<boolean>) {
      state.EditWorkingTimeModalOpen = action.payload;
    },
    setActiveBreakingTimeAttendanceId(
      state,
      action: PayloadAction<string | null>
    ) {
      state.activeBreakingTimeAttendanceId = action.payload;
    },
    setBreakingTimeModalOpen(state, action: PayloadAction<boolean>) {
      state.BreakingTimeModalOpen = action.payload;
    },
    // setCustomerForm(state, action: PayloadAction<CustomerFormType>) {
    //   state.CustomerValues = action.payload;
    // setCustomerForm(state, action: PayloadAction<CustomerFormType>) {
    //   state.CustomerValues = action.payload;
    // },
    // resetCustomerForm(state) {
    //   state.CustomerValues = {
    //     customerInfo: {
    //       register_store_id: '',
    //       entity_type: '0',
    //       accountNumber: '',
    //       first_name: '',
    //       cardId: '',
    //       branchCode: '',
    //       address_2: '',
    //       birthDate: '',
    //       gender: '0',
    //       comments: '',
    //     },
    //     customerAddress: {
    //       isNewAddress: true,
    //       address_1: '',
    //       zip: '',
    //       shippingAddress: '',
    //       city: '',
    //       state: '',
    //       province_id: '',
    //       district_id: '',
    //       sub_district_id: '',
    //     },
    //     customerContact: {
    //       last_name: '',
    //       phoneNumber: '',
    //       email: '',
    //       facebook: '',
    //       line: '',
    //       instagram: '',
    //     },
    //     customerFinancialInfo: {
    //       groupPrice: '0',
    //       isTaxable: '0',
    //     },
    //     customerCreditInfo: {
    //       dateLimit: '',
    //       receivableLimit: '',
    //     },
    //     pickupAddresses: [],
    //   };
    // },
    setEditWorkingTimeValues(
      state,
      action: PayloadAction<EditWorkingTimeFormType>
    ) {
      state.EditWorkingTimeValues = action.payload;
    },
    setBreakingTimeValues(
      state,
      action: PayloadAction<EditBreakingTimeRowType[]>
    ) {
      state.BreakingTimeValues = action.payload;
    },
    setShowAllValidateCustomerErrors(state, action: PayloadAction<boolean>) {
      state.showAllValidateErrors = action.payload;
    },
    setCountCustomerSubmit(state) {
      state.countSubmit += 1;
    },
    setPageFilters: (state, action) => {
      state.PageFilters = action.payload;
    },
    setDateFilters: (state, action) => {
      state.PageFilters.startDate = action.payload.startDate;
      state.PageFilters.endDate = action.payload.endDate;
    },
    setPageFiltersBranch: (state, action) => {
      state.PageFilters.branch = action.payload;
    },
    clearPageFilters: (state) => {
      state.PageFilters = {
        branch: [],
        ...getDefaultDateRange(),
        officeID: null,
      };
    },
    setEntriesPerPage: (state, action) => {
      state.PageDetails.entriesPerPage = action.payload;
    },
    setCurrentPage: (state, action) => {
      state.PageDetails.currentPage = action.payload;
      state.PageDetails.inputPageValue = action.payload + 1;
    },
    setInputPageValue: (state, action) => {
      state.PageDetails.inputPageValue = action.payload;
    },

    // setActivePointsHistoryIndex: (state, action) => {
    //   state.PointsHistoryModal.activePointsHistoryIndex = action.payload;
    // },
    // setPointsHistoryModalOpen: (state, action) => {
    //   state.PointsHistoryModal.PointsHistoryModalOpen = action.payload;
    // },
    // setPointsHistoryInfoValues: (state, action) => {
    //   state.PointsHistoryModal.PointsHistoryValues.info = action.payload;
    // },
    // setPointsHistoryTransactionValues: (state, action) => {
    //   state.PointsHistoryModal.PointsHistoryValues.points_history =
    //     action.payload;
    // },
    // setShowAllValidatePointsHistoryErrors: (state, action) => {
    //   state.PointsHistoryModal.showAllValidateErrors = action.payload;
    // },
    // setCountPointsHistorySubmit: (state) => {
    //   state.PointsHistoryModal.countSubmit += 1;
    // },
    // setPointsHistoryEditKey: (state, action) => {
    //   state.PointsHistoryModal.EditKey = action.payload;
    // },

    // setPointsHistoryEntriesPerPage: (state, action) => {
    //   state.PointsHistoryModal.PageDetails.entriesPerPage = action.payload;
    // },
    // setPointsHistoryCurrentPage: (state, action) => {
    //   state.PointsHistoryModal.PageDetails.currentPage = action.payload;
    //   state.PointsHistoryModal.PageDetails.inputPageValue = action.payload + 1;
    // },
    // setPointsHistoryInputPageValue: (state, action) => {
    //   state.PointsHistoryModal.PageDetails.inputPageValue = action.payload;
    // },
  },
});

export const {
  setActiveWorkingTimeId,
  setWorkingTimeModalOpen,
  setActiveBreakingTimeAttendanceId,
  setBreakingTimeModalOpen,
  setEditWorkingTimeValues,
  setBreakingTimeValues,
  // setCustomerModalOpen,
  // setAdjustPointsModalOpen,
  setActiveEditWorkingTimeId,
  // setCustomerForm,
  // resetCustomerForm,
  // setAdjustPointsForm,
  setShowAllValidateCustomerErrors,
  setCountCustomerSubmit,
  setPageFilters,
  setPageFiltersBranch,
  setDateFilters,
  clearPageFilters,
  setEntriesPerPage,
  setCurrentPage,
  setInputPageValue,
  // setActivePointsHistoryIndex,
  // setPointsHistoryModalOpen,
  // setPointsHistoryInfoValues,
  // setPointsHistoryTransactionValues,
  // setShowAllValidatePointsHistoryErrors,
  // setCountPointsHistorySubmit,
  // setPointsHistoryEditKey,
  // setPointsHistoryEntriesPerPage,
  // setPointsHistoryCurrentPage,
  // setPointsHistoryInputPageValue,
} = TimeAttendanceSlice.actions;

export default TimeAttendanceSlice.reducer;
